import { render } from "./GeneralSelect.vue?vue&type=template&id=a2089922&scoped=true"
import script from "./GeneralSelect.vue?vue&type=script&lang=js"
export * from "./GeneralSelect.vue?vue&type=script&lang=js"

import "./GeneralSelect.vue?vue&type=style&index=0&id=a2089922&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2089922"]])

export default __exports__